module.exports = __webpack_public_path__ + "media/images/application/icons/search-black-4e4ea3ebcde4b5259edd0a4a75cfeb82.svg";